<template>
  <div class="page-wrap stack-lg profile-page">
    <BaseCard class="profile-card">
      <SectionTitle
        eyebrow="Профиль"
        title="Настройки профиля"
        subtitle="Только основные данные аккаунта без лишних вкладок."
      />

      <form class="profile-form" @submit.prevent="saveProfile">
        <BaseInput
          v-model="form.full_name"
          label="Имя и фамилия"
          placeholder="Введите имя"
        />

        <div class="grid-two">
          <BaseInput
            :model-value="form.phone"
            type="tel"
            label="Телефон"
            placeholder="+7 917 131 57 89"
            autocomplete="tel"
            inputmode="tel"
            maxlength="16"
            disabled
            @update:modelValue="updatePhone"
          />
          <BaseInput
            :model-value="user?.email || ''"
            label="Email"
            disabled
          />
        </div>

        <p v-if="error" class="message message--error">{{ error }}</p>
        <p v-if="success" class="message message--success">{{ success }}</p>

        <BaseButton type="submit" block :loading="loading">
          Сохранить профиль
        </BaseButton>
      </form>
    </BaseCard>
  </div>
</template>

<script>
import BaseButton from '../components/ui/BaseButton.vue';
import BaseCard from '../components/ui/BaseCard.vue';
import BaseInput from '../components/ui/BaseInput.vue';
import SectionTitle from '../components/ui/SectionTitle.vue';
import { formatRuPhone, normalizeRuPhoneDigits } from '../utils/ruPhone';

export default {
  name: 'ProfileView',
  components: {
    BaseButton,
    BaseCard,
    BaseInput,
    SectionTitle,
  },
  data() {
    return {
      success: '',
      form: {
        full_name: '',
        phone: '',
        club_id: '',
      },
    };
  },
  computed: {
    user() {
      return this.$store.getters['auth/user'];
    },
    clubs() {
      return this.$store.getters['clubs/clubs'];
    },
    currentClub() {
      return this.$store.getters['clubs/currentClub'];
    },
    loading() {
      return this.$store.getters['auth/loading'];
    },
    error() {
      return this.$store.getters['auth/error'];
    },
    membership() {
      if (Number(this.user?.is_admin || 0) === 1) {
        return 'Администратор';
      }

      const points = Number(this.user?.bonus_balance || 0);
      if (points >= 500) return 'Event Horizon';
      if (points >= 150) return 'Core';
      return 'Стандарт';
    },
  },
  watch: {
    user: {
      immediate: true,
      handler() {
        this.syncForm();
      },
    },
  },
  async mounted() {
    await this.$store.dispatch('clubs/fetchClubs');

    if (this.user?.club_id) {
      await this.$store.dispatch('clubs/fetchClubById', this.user.club_id);
    }
  },
  methods: {
    syncForm() {
      this.form = {
        full_name: this.user?.full_name || '',
        phone: formatRuPhone(this.user?.phone || ''),
        club_id: this.user?.club_id ? String(this.user.club_id) : '',
      };
    },
    updatePhone(value) {
      this.form.phone = formatRuPhone(value);
    },
    async saveProfile() {
      this.success = '';
      this.$store.dispatch('auth/clearError');

      const nextClubId = this.form.club_id ? Number(this.form.club_id) : null;

      const result = await this.$store.dispatch('auth/updateProfile', {
        full_name: this.form.full_name,
        phone: normalizeRuPhoneDigits(this.form.phone),
        club_id: nextClubId,
      });

      if (!result?.ok) {
        return;
      }

      if (nextClubId) {
        await Promise.all([
          this.$store.dispatch('clubs/fetchClubById', nextClubId),
          this.$store.dispatch('booking/initBooking', nextClubId),
        ]);
      } else {
        this.$store.dispatch('booking/resetState');
      }

      this.success = 'Профиль обновлён.';
    },
  },
};
</script>

<style scoped src="./ProfileView.css"></style>